import Vue from 'vue';
import App from './App';
import router from './router/index';
import store from './store';
import { i18n } from './i18n';
import './index.css';
import Vuelidate from 'vuelidate';

import PaperDashboard from './plugins/paperDashboard';
import 'vue-notifyjs/themes/default.css';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import VueGtag from 'vue-gtag';
import VuePageTitle from 'vue-page-title';
const VueUploadComponent = require('vue-upload-component');

Vue.use(Vuelidate);

Bugsnag.start({
  onError: function (event) {
    if (store.getters.user) {
      event.setUser(
        store.getters.user.user_id,
        store.getters.user.email,
        store.getters.user.first_name + ' ' + store.getters.user.last_name
      );
    }
  },
  enabledReleaseStages: ['production'],
  apiKey: '4b66e8358ac62394ea6e3a337c1fd84c',
  plugins: [new BugsnagPluginVue()],
});

let host = window.location.hostname;

const bugsnagVue = Bugsnag.getPlugin('vue');

Vue.use(
  VueGtag,
  {
    config: { id: 'G-BPZ2RBFHTW' },
    appName: 'VividLeaf',
    pageTrackerScreenviewEnabled: true,
  },
  router
);

Vue.component('file-upload', VueUploadComponent);
Vue.use(PaperDashboard);
Vue.use(bugsnagVue);
Vue.use(VuePageTitle, {
  router,
  suffix: '- Vivid Leaf',
});

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
